import { render, staticRenderFns } from "./screen_bodegas.vue?vue&type=template&id=263edde6"
import script from "./screen_bodegas.vue?vue&type=script&lang=js"
export * from "./screen_bodegas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports